import { render } from "./Main.vue?vue&type=template&id=3859857f&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=3859857f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3859857f"

export default script